export const transactionTypes = [
  {
    label: 'Buy',
    value: 'BUY',
    selected: true,
  },
  {
    label: 'Gift',
    value: 'GIFT',
    selected: true,
  },
  {
    label: 'Option Exercised',
    value: 'OPTION EXERCISED',
    selected: true,
  },
  {
    label: 'Sell',
    value: 'SELL',
    selected: true,
  },
  {
    label: 'Other',
    value: 'OTHER',
    selected: true,
  },
];

export default transactionTypes;
